import { cn } from '../../lib/cn';

/**
 * The §4.1 link recipe, exported so a router link can wear it.
 *
 * `Link` styles a plain `<a>`, which is right for external URLs and wrong for
 * internal navigation: a bare anchor to an internal page reloads the whole SPA,
 * and on this site that means re-fetching the menus and settings on every
 * click. The SPAs therefore render *their router's* link component — and need
 * the classes without the element.
 *
 * Same reasoning as `CONTROL_CLASSES` in `Field`: the recipe is the shared
 * thing, and duplicating it in an app is how a design system starts to drift.
 */
export function linkClasses(options: { subtle?: boolean } = {}, className?: string): string {
  const { subtle = false } = options;

  return cn(
    'text-link underline-offset-2 transition-colors duration-fast',
    subtle ? 'no-underline hover:underline' : 'underline decoration-transparent',
    !subtle && 'hover:decoration-current',
    className,
  );
}
